import React from "react"
import { Navigate } from "react-router-dom"
import { useAuth } from "../contexts/AuthContext"
import { Box, CircularProgress, Alert, Container } from "@mui/material"

const ProtectedRoute = ({ children }) => {
  const { currentUser, isAdmin, loading } = useAuth()

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
        <CircularProgress size={60} />
      </Box>
    )
  }

  if (!currentUser) {
    return <Navigate to="/admin/login" replace />
  }

  if (!isAdmin) {
    return (
      <Container maxWidth="sm" sx={{ py: 8 }}>
        <Alert severity="error">Access Denied. You do not have administrator privileges.</Alert>
      </Container>
    )
  }

  return children
}

export default ProtectedRoute
